export default __webpack_public_path__ + "static/media/USK_18.ca72942a.png";